/* istanbul ignore file */
import React from 'react'
import type {
  primitives,
  AuctionBlueprintScheduledOnlineReactiveArgs,
} from '@adc/blueprint'
import type { Property, Listing, Maybe } from '@adc/sdk/types'
import type { FeatureFlags } from '@adc/ui-adc'
import SaleTerms from 'common/modules/redesign/saleTerms'
import MainSectionPanel from 'common/modules/redesign/mainSectionPanel'
import ListingSelector from 'common/modules/redesign/listingSelector'
import {
  PropertyPageActionsType,
  PropertyProvider,
  SavedPropertiesDataType,
} from 'common/context/property'
import PropertyHeader from '../modules/redesign/propertyHeader'
import MessagesBanner from '../modules/redesign/messagesBanner'
import PropertyDetails from '../modules/redesign/propertyDetails'
import Breadcrumbs from '../modules/breadcrumbs'
import Documents from '../modules/documents'
import { Faqs } from '../modules/faqs'
import PhotoGallery from '../modules/redesign/photoGallery'
import InvestmentInfo from '../modules/redesign/investmentInfo'
import TransactionDetails from '../modules/transactionDetails'
import SimilarPropertiesCarousel from '../modules/similarProperties'
import DueDiligence from '../modules/dueDiligence'
import { StickyHeader } from '../modules/stickyHeader'
import HelpCenter from '../modules/helpCenter'
import { ConnectedCompSales } from '../modules/compsales'
import SeoLinksFooter from '../modules/seoLinksFooter'
import Disclaimer from '../modules/disclaimer'
import ImportantInformationSection from '../modules/redesign/importantInformation'
import {
  CombinedListingType,
  ListingPageActionsType,
  ListingProvider,
} from '../context/listing'
import ActivePropertyWrapperContainer, {
  ApplicationBidBanner,
} from './activePropertyWrapper'
type AuctionUser = primitives.AuctionUser
interface RedesignedPropertyContentProps {
  segment: AuctionBlueprintScheduledOnlineReactiveArgs['segment']
  listing: CombinedListingType
  featureFlags: FeatureFlags
  pageBannerRef: any
  user: AuctionUser
  isOnline: Maybe<boolean> | undefined
  listingActions: ListingPageActionsType
  activeListings: Listing[]
  property: Property
  propertyActions: PropertyPageActionsType
  savedPropertiesData: SavedPropertiesDataType
}

const RedesignedPropertyContent = ({
  segment,
  listing,
  pageBannerRef,
  isOnline,
  listingActions,
  activeListings,
  property,
  propertyActions,
  savedPropertiesData,
}: RedesignedPropertyContentProps) => {
  // TODO: check if segment is used in any components that assume it's live auction segment and point those to live_segment instead, once sure it's safe, change segment to only populate if it's OnlineAuctionSegment typename
  return (
    <PropertyProvider
      property={property}
      propertyActions={propertyActions}
      savedPropertiesData={savedPropertiesData}
    >
      <ListingProvider
        listing={listing}
        segment={segment}
        listingActions={listingActions}
        activeListings={activeListings}
      >
        <div data-elm-id='redesigned_pdp_content'>
          <StickyHeader isRedesign />
          <Breadcrumbs isRedesign />
          <MessagesBanner pageBannerRef={pageBannerRef} />
          <ApplicationBidBanner listing={listing} segment={segment} />
          <MainSectionPanel>
            <PropertyHeader />
            <PhotoGallery />
            <InvestmentInfo />
            <ListingSelector />
            <SaleTerms />
          </MainSectionPanel>
          <ImportantInformationSection />
          <PropertyDetails />
          {/* @ts-ignore js redux file */}
          <SimilarPropertiesCarousel />
          <ConnectedCompSales />
          {/* @ts-ignore types are wrong here */}
          <DueDiligence segment={segment} isOnline={isOnline} />
          <Documents />
          <Faqs />
          <TransactionDetails />
          <HelpCenter />
          <Disclaimer />
          <SeoLinksFooter />
        </div>
      </ListingProvider>
    </PropertyProvider>
  )
}

interface RedesignedPropertyContainerProps {
  pageBannerRef: any
}

const RedesignedPropertyContainer = (
  props: RedesignedPropertyContainerProps
) => (
  <ActivePropertyWrapperContainer
    {...props}
    childComponent={RedesignedPropertyContent}
  />
)

export default RedesignedPropertyContainer
